module.exports = __webpack_public_path__ + "static/pic08-4c3ce95d53bcf4f4e5c3079df9c3e543.jpg";